function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "icon",
  d: "M67.584,45.794,51.329,32.53a2.245,2.245,0,0,0-2.819,0L32.259,45.794a.559.559,0,0,0-.081.785l.705.866a.558.558,0,0,0,.782.083l2.853-2.33V62.163a1.117,1.117,0,0,0,1.117,1.117h8.936a1.117,1.117,0,0,0,1.117-1.117V53.227l4.468.021v8.942a1.117,1.117,0,0,0,1.117,1.117l8.936-.023a1.117,1.117,0,0,0,1.117-1.117V45.2l2.853,2.33a.558.558,0,0,0,.785-.081l.705-.866a.558.558,0,0,0-.084-.787Zm-6.5,15.26h.007l-6.7.021V52.128a1.12,1.12,0,0,0-1.114-1.117l-6.7-.019a1.117,1.117,0,0,0-1.12,1.117v8.946h-6.7V43.375l11.17-9.115,11.17,9.115Z",
  transform: "translate(-32.054 -32.033)",
  fill: "#fff"
});

var SvgHome = function SvgHome(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35.74,
    height: 31.274,
    viewBox: "0 0 35.74 31.274",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHome, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/home.b415c234.svg";
export { ForwardRef as ReactComponent };